import { nanoid } from "nanoid";

export default function connectomicsSlice(set, get) {
  return {
    // The store keeps an array of experiments.
    // We define actions for add/remove/modify an experiment:

    addConnectomicsExperiment: (sourceExpId) => {
      // copy the state from an existing experiment:
      const state = get();
      const experimentsArr = state.connectomicsExperimentsArr;
      const currentCounter = state.connectomicsExpCounter;

      // Find existing experiment to clone
      const sourceExp = experimentsArr.find((exp) => exp.id === sourceExpId);

      // Generate new ID
      const newExpId = `connectomicsExp-${nanoid(4)}`;
      // Clone the experiment
      const newExp = {
        ...sourceExp,
        id: newExpId,
        displayNumber: currentCounter,
      };

      // Insert into array with new ID
      set((prev) => ({
        connectomicsExperimentsArr: [
          ...prev.connectomicsExperimentsArr,
          newExp,
        ],
        connectomicsExpCounter: prev.connectomicsExpCounter + 1,
      }));

      // Return the new ID so the UI can switch to it
      return newExpId;
    },

    removeConnectomicsExperiment: (id) => {
      set((prev) => ({
        connectomicsExperimentsArr: prev.connectomicsExperimentsArr.filter(
          (exp) => exp.id !== id
        ),
        // Counter does NOT decrease here
      }));
    },

    setConnectomicsValues: (id, property, value) => {
      set((prev) => ({
        connectomicsExperimentsArr: prev.connectomicsExperimentsArr.map((exp) =>
          exp.id === id ? { ...exp, [property]: value } : exp
        ),
      }));
    },

    // ---------------------------------------------------------------------------

    // set Microscopy approach with custom logic for a specific experiment
    setMicroscopyApproach: (id, microscopyApproach) => {
      set((prev) => ({
        connectomicsExperimentsArr: prev.connectomicsExperimentsArr.map(
          (exp) => {
            if (exp.id === id) {
              // Start with the updated approach
              const updatedExp = { ...exp, microscopyApproach };

              // ↓ if switching to non-compatible Microscopy approach, uncheck Molecular annotation
              if (
                microscopyApproach !== "expansion-microscopy" &&
                microscopyApproach !== "barcoding"
              ) {
                updatedExp.molecularAnnotation = false;
                // Optionally reset numberOfMolecules too if molecularAnnotation is false
                updatedExp.numberOfMolecules = 10; // Default from initialState
              }
              return updatedExp;
            }
            return exp; // Return unchanged experiment if ID doesn't match
          }
        ),
      }));
    },
  };
}
